/* ============================================================
   Gatsby Canvas — Advertorial #4 v2 — Brain Off Switch
   - Inject body class for distraction-free layout
   - Sources accordion: toggle open/closed + chevron rotation
   - (Sticky promo bar uses pure CSS position:sticky; no JS)
   ============================================================ */

(function () {
  'use strict';

  const root = document.querySelector('.adv--brainoff-v2');
  if (!root) return;

  // Hide theme header/footer/announcement bar via body class
  document.body.classList.add('adv-brainoff-v2-page');

  // ---------- Sources accordion ----------
  const trigger = root.querySelector('[data-accordion-trigger]');
  const panel = root.querySelector('[data-accordion-panel]');

  if (trigger && panel) {
    trigger.addEventListener('click', function () {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      const next = !isOpen;
      trigger.setAttribute('aria-expanded', next ? 'true' : 'false');
      panel.setAttribute('data-state', next ? 'open' : 'closed');
    });
  }

  // ---------- Comment form (decorative — prevent reload) ----------
  const form = root.querySelector('[data-comment-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // Decorative form. Real backend wiring TBD.
      // Confirm visually that submit worked.
      const btn = form.querySelector('.adv-btn-publish');
      if (btn) {
        const original = btn.textContent;
        btn.textContent = 'Thanks!';
        btn.disabled = true;
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
          form.reset();
        }, 1500);
      }
    });
  }
})();
